module.exports = __webpack_public_path__ + "img/i_m_btn_internet.fa1647ce.svg";